import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { RelatieSpecificaService } from '../relatie-specifica.service';
import { RelatieSpecificaAddPayload } from '../relatie-specifica.interface';

@Component({
    selector: 'app-add-relatie-specifica',
    templateUrl: './add-relatie-specifica.component.html',
    styleUrls: ['./add-relatie-specifica.component.scss']
})
export class AddRelatieSpecificaComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        gender: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddRelatieSpecificaComponent>,
        private requestService: RelatieSpecificaService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description, gender } = this.form
            .value as RelatieSpecificaAddPayload;
        const payload: RelatieSpecificaAddPayload = {
            name,
            slug,
            description,
            gender
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
